import { useEffect, useRef } from 'react';

const SPEED_PX_PER_SEC = 18;
const END_PAUSE_MS = 5000;
const TOP_PAUSE_MS = 2500;
const IDLE_RESUME_MS = 30000;
const EVENTS = ['wheel', 'touchstart', 'pointerdown', 'mousemove', 'keydown'];

// Slowly scrolls a list for TV viewing; pauses on hover/manual scroll and loops back to the top.
export const useAutoScroll = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let raf; let last = null; let pos = el.scrollTop; let atEnd = false;
    let holdUntil = performance.now() + TOP_PAUSE_MS; let pausedUntil = 0; let hovering = false;
    const interact = () => { pausedUntil = performance.now() + IDLE_RESUME_MS; };
    const onScroll = () => { if (Math.abs(el.scrollTop - pos) > 1.5) { pos = el.scrollTop; atEnd = false; interact(); } };
    const onEnter = () => { hovering = true; interact(); };
    const onLeave = () => { hovering = false; interact(); };
    const tick = (now) => {
      const dt = last === null ? 0 : now - last;
      last = now;
      const max = el.scrollHeight - el.clientHeight;
      if (hovering || now < pausedUntil) {
        pos = el.scrollTop;
      } else if (max > 0 && now >= holdUntil) {
        if (pos >= max - 1) {
          if (!atEnd) { atEnd = true; holdUntil = now + END_PAUSE_MS; } else { atEnd = false; pos = 0; el.scrollTop = 0; holdUntil = now + TOP_PAUSE_MS; }
        } else {
          pos = Math.min(max, pos + (SPEED_PX_PER_SEC * dt) / 1000);
          el.scrollTop = pos;
        }
      }
      raf = requestAnimationFrame(tick);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    EVENTS.forEach((e) => el.addEventListener(e, interact, { passive: true }));
    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener('scroll', onScroll);
      EVENTS.forEach((e) => el.removeEventListener(e, interact));
      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, []);
  return ref;
};
